import { SET_KILLSWITCHES } from 'store/ducks/killswitch/types';

function cleanState(state) {
  state.airplaneAllowList = state.airplaneAllowList || [];
}

const killswitch = (state = {}, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_KILLSWITCHES:
      const nextState = { ...state, ...payload };
      cleanState(nextState);
      return nextState;
    default:
      return state;
  }
};

export default killswitch;
